var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "calendar_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "calendar_svg__calendar"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-1 18H5c-.55 0-1-.45-1-1V8h16v12c0 .55-.45 1-1 1",
    className: "calendar_svg__vector"
  }))));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5DYWxlbmRhcjwvdGl0bGU+PGcgY2xhc3M9ImNhbGVuZGFyIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yMCAzaC0xVjJjMC0uNTUtLjQ1LTEtMS0xcy0xIC40NS0xIDF2MUg3VjJjMC0uNTUtLjQ1LTEtMS0xcy0xIC40NS0xIDF2MUg0Yy0xLjEgMC0yIC45LTIgMnYxNmMwIDEuMS45IDIgMiAyaDE2YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJabS0xIDE4SDVjLS41NSAwLTEtLjQ1LTEtMVY4aDE2djEyYzAgLjU1LS40NSAxLTEgMVoiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";